(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class EventStore {
    /**
     * Initializes a new instance of the class and sets up an empty array for listeners.
     */
    constructor() {
      this.listeners = [];
    }

    /**
     * Adds an event listener to the specified node and stores a function to remove it later.
     *
     * @param {EventTarget} node - The target node to attach the event listener to.
     * @param {string} type - The type of the event to listen for (e.g., 'click', 'mouseover').
     * @param {Function} handler - The function to handle the event.
     * @param {Object|boolean} [options] - Optional options for addEventListener
     * (e.g., { passive: true } or useCapture boolean).
     * @returns {this} Returns the current instance for chaining.
     */
    add(node, type, handler, options) {
      const opts = !options ? { passive: true } : options;

      node.addEventListener(type, handler, opts);
      const removeListener = function () {
        node.removeEventListener(type, handler, opts);
      };

      this.listeners.push(removeListener);
      return this;
    }

    /**
     * Removes all event listeners by invoking each listener's removal function.
     * After execution, the listeners array will only contain listeners that were not successfully removed.
     */
    clear() {
      this.listeners = this.listeners.filter((remove) => remove());
    }
  }

  global.NewHomeSource.Carousel.EventStore = EventStore;
}(window));
